import { render } from "./recharges.vue?vue&type=template&id=222cb646"
import script from "./recharges.vue?vue&type=script&lang=js"
export * from "./recharges.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__